import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import IOSSwitch from '../../../../components/IOSSwitch';
import Notification_Edit from '../../../../assets/images/Notification_Edit.svg';
import Update_Mail from '../../../../assets/images/Update_Mail.svg';
import Update_Phone from '../../../../assets/images/Upadate_Phone.svg';
import Success_Update from '../../../../assets/images/Success_Popup_img.svg';
import PersonalDetailPopup from '../../../../components/personalDetailPopup';
import { useHook as CustomerHook } from '../useHook';
import { useSelector } from 'react-redux';

const NotificatiopnPreference = () => {
  const { fetchCustomerInfo, updateCustomerNotificationPref } = CustomerHook();
  const { customerInformation } = useSelector(
    (state: any) => state.profileManagement,
  );
  const [notificatiopnPreference, setNotificatiopnPreference] = useState({
    email: false,
    mobile: false,
  });
  const [openMailDialog, setOpenMailDialog] = useState(false);
  const [openMobileDialog, setOpenMobileDialog] = useState(false);
  const [openMobileVerifyDialog, setOpenMobileVerifyDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [activeEditButton, setActiveButton] = useState(false);

  //updateMailpopup
  const handleClosePopup = () => {
    setOpenMailDialog(false);
  };
  const handleMailVerify = (data: any) => {
    console.log(data);
  };
  const mailPopupProps = {
    open: openMailDialog,
    handleClose: handleClosePopup,
    handleSubmit: handleMailVerify,
    title: 'Email',
    contentHeading: 'Are you sure, you want to change your email id?',
    contentSubHeading: 'rohanshukla32@email.com',
    btnText: 'Verify',
    imgURL: Update_Mail,
  };

  //updateMobilepopup
  const handleCloseMobilePopup = () => {
    setOpenMobileDialog(false);
  };
  const handleMobileVerify = (data: any) => {
    setOpenMobileVerifyDialog(true);
  };
  const mobilePopupProps = {
    open: openMobileDialog,
    handleClose: handleCloseMobilePopup,
    handleSubmit: handleMobileVerify,
    title: 'Mobile Number',
    contentHeading: 'Are you sure, you want to change your contact number?',
    contentSubHeading: '+91 9192934556',
    btnText: 'Verify',
    imgURL: Update_Phone,
  };

  //updateMobilepopup
  const handleCloseMobileVerifyPopup = () => {
    setOpenMobileVerifyDialog(false);
  };
  const handleMobileProceed = (data: any) => {
    setOpenSuccessDialog(true);
  };
  const mobileVerifyPopupProps = {
    open: openMobileVerifyDialog,
    handleClose: handleCloseMobileVerifyPopup,
    handleSubmit: handleMobileProceed,
    title: 'Mobile Number',
    contentHeading: (
      <>
        Enter the verification code sent on <br /> +1(91)*********-5222
      </>
    ),
    btnText: 'Verify & Proceed',
    imgURL: Update_Phone,
  };

  //success verify popup
  const handleCloseSuccessPopup = () => {
    setOpenSuccessDialog(false);
  };

  //Notificatiopn Preference Chnage
  const handlChangeNotificatiopnPreference = (event: any) => {
    const { name, checked } = event.target;
    setNotificatiopnPreference((prev) => {
      return { ...prev, [name]: checked };
    });
    setActiveButton(true);
  };

  //setIntial Value
  useEffect(() => {
    setNotificatiopnPreference({
      email: customerInformation?.notificationPreference?.includes('email'),
      mobile: customerInformation?.notificationPreference?.includes('sms'),
    });
  }, [customerInformation]);

  const handleSubmit = async () => {
    const preference = [];

    if (notificatiopnPreference?.email) {
      preference.push('email');
    }
    if (notificatiopnPreference?.mobile) {
      preference.push('sms');
    }
    const payload = {
      customerID: customerInformation.customerID,
      preference: preference,
    };
    await updateCustomerNotificationPref(payload);
    await fetchCustomerInfo();
  };

  return (
    <>
      <section className="personal_details">
        <div className="personal_details_card">
          <div className="personal_details_card_lable_field">
            <h4>Email</h4>
            <div className="personal_details_card_lable_edit-field">
              <h5>{customerInformation?.email || ''}</h5>
              {/* <Button onClick={() => setOpenMailDialog(true)}>
                <img src={Notification_Edit} alt="Notification Edit" />
              </Button> */}
            </div>
          </div>
          <div className="personal_details_card_input_field">
            <div className="personal_details_card_input_field-switch">
              <IOSSwitch
                sx={{ m: 1 }}
                name="email"
                checked={notificatiopnPreference.email}
                onChange={handlChangeNotificatiopnPreference}
              />
            </div>
          </div>
        </div>

        <div className="personal_details_card">
          <div className="personal_details_card_lable_field">
            <h4>Contact Number</h4>
            <div className="personal_details_card_lable_edit-field">
              <h5>+91 {customerInformation?.mobileNo || ''}</h5>
              {/* <Button onClick={() => setOpenMobileDialog(true)}>
                <img src={Notification_Edit} alt="Notification Edit" />
              </Button> */}
            </div>
          </div>
          <div className="personal_details_card_input_field">
            <div className="personal_details_card_input_field-switch">
              <IOSSwitch
                sx={{ m: 1 }}
                name="mobile"
                checked={notificatiopnPreference.mobile}
                onChange={handlChangeNotificatiopnPreference}
              />
            </div>
          </div>
        </div>

        <div className="personal_details_card_action">
          <Button
            onClick={handleSubmit}
            className={
              activeEditButton
                ? 'personal_details_card_action-save'
                : 'personal_details_card_action-save disable_button_background'
            }
            disabled={!activeEditButton}
          >
            Save
          </Button>
        </div>
      </section>

      <PersonalDetailPopup {...mailPopupProps} />
      <PersonalDetailPopup {...mobilePopupProps} />
      <PersonalDetailPopup {...mobileVerifyPopupProps} />
      <Dialog
        className="renew-popup"
        open={openSuccessDialog}
        onClose={handleCloseSuccessPopup}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogContent className="renew_dialog-content">
          <div className="update_success_dialog-content">
            <img src={Success_Update} alt="Success_Update" />
            <div>
              <h4>successfully Verify</h4>
              <h5>
                Your contact number +91 36568 12325 is <br /> updated
                successfully.
              </h5>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="update_success_dialog_btn">
            <Button onClick={handleCloseSuccessPopup}>Done</Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NotificatiopnPreference;
